import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { DAY_MS } from 'common/util/time'

dayjs.extend(relativeTime)

export function fromNow(time: number) {
  return dayjs(time).fromNow()
}

const FORMATTER = new Intl.DateTimeFormat('default', {
  dateStyle: 'medium',
  timeStyle: 'medium',
})

const FORMATTER_WITH_TIMEZONE = new Intl.DateTimeFormat('default', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  timeZoneName: 'short',
})

export const formatTime = FORMATTER.format
export const formatTimeWithTimezone = FORMATTER_WITH_TIMEZONE.format

export function getLocalTimezoneShort() {
  return new Intl.DateTimeFormat('default', {
    timeZoneName: 'short',
  })
    .formatToParts(new Date())
    .find((part) => part.type === 'timeZoneName')?.value
}

export function formatJustDateShort(time: number) {
  return dayjs(time).format('MMM D, YYYY')
}

export function formatTimeShort(time: number) {
  return dayjs(time).format('MMM D, h:mma')
}

export function formatJustTime(time: number) {
  return dayjs(time).format('h:mma')
}

export const getCountdownString = (endDate: Date, includeSeconds = false) => {
  const remainingTimeMs = endDate.getTime() - Date.now()
  const isPast = remainingTimeMs < 0

  const seconds = Math.floor(Math.abs(remainingTimeMs) / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  const hoursStr = `${hours % 24}h`
  const minutesStr = `${minutes % 60}m`
  const daysStr = days > 0 ? `${days}d` : ''
  const secondsStr = includeSeconds ? ` ${seconds % 60}s` : ''
  return `${
    isPast ? '-' : ''
  }${daysStr} ${hoursStr} ${minutesStr} ${secondsStr}`
}

export const getCountdownStringHoursMinutes = (endDate: Date) => {
  const remainingTimeMs = endDate.getTime() - Date.now()
  const isPast = remainingTimeMs < 0

  const seconds = Math.floor(Math.abs(remainingTimeMs) / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  const hoursStr = `${hours % 24}h`
  const minutesStr = `${minutes % 60}m`

  return `${isPast ? '-' : ''} ${hoursStr} ${minutesStr}`
}
export const customFormatTime = (time: number) => {
  if (time > Date.now() - DAY_MS) {
    return formatJustTime(time)
  }
  return formatTimeShort(time)
}
